/**
 * @ignore
 * @internal
 * */
export abstract class Request {
  type: unknown[] = []
  data: any = null;

  isType(type: unknown) {
    return this.type.includes(type);
  }
}

